// #513: Eigentümer am Ticket (tickets.eigentuemer_id) – Kandidaten aus Einheit bzw. Objekt.
// In einer WEG hängen die Eigentümer an den Einheiten (einheit_eigentuemer), nicht am Objekt;
// ohne Einheit am Ticket werden deshalb die laufenden Eigentümer ALLER Einheiten des Objekts angeboten.
import { supabase } from '../supabase/client';
import { istAktuell, type EinheitEigZeitraum } from '../eigentuemer/einheitEigentum';

type Zeile = { eigentuemer_id: string } & EinheitEigZeitraum;

/** Rein: laufende Eigentümer-IDs (ohne Doppelte), Reihenfolge wie geliefert. */
export function laufendeEigentuemerIds(zeilen: readonly Zeile[], heute: string): string[] {
  return [...new Set(zeilen.filter(z => istAktuell(z, heute)).map(z => z.eigentuemer_id))];
}

/** Rein: verknüpfter Eigentümer zuerst, dann die übrigen Kandidaten. */
export function mitVerknuepftem(verknuepft: string | null | undefined, ids: readonly string[]): string[] {
  return verknuepft ? [verknuepft, ...ids.filter(i => i !== verknuepft)] : [...ids];
}

/**
 * Eigentümer-IDs für ein Ticket: Einheit → deren laufende Eigentümer; sonst Objekt-Eigentümer
 * (Mietverwaltung); sonst laufende Eigentümer aller Einheiten des Objekts (WEG).
 */
export async function ladeEigentuemerIds(objektId: string | null | undefined, einheitId: string | null | undefined): Promise<string[]> {
  const heute = new Date().toISOString().slice(0, 10);
  if (einheitId) {
    const { data } = await supabase.from('einheit_eigentuemer').select('eigentuemer_id, vertrag_ab, vertrag_bis').eq('einheit_id', einheitId);
    const ids = laufendeEigentuemerIds((data || []) as Zeile[], heute);
    if (ids.length) return ids;
  }
  if (!objektId) return [];
  const { data: obj } = await supabase.from('objekt_eigentuemer').select('eigentuemer_id').eq('objekt_id', objektId);
  const objIds = [...new Set(((obj || []) as { eigentuemer_id: string }[]).map(r => r.eigentuemer_id))];
  if (objIds.length) return objIds;
  const { data: einheiten } = await supabase.from('objekt_einheiten').select('id').eq('objekt_id', objektId);
  const eIds = ((einheiten || []) as { id: string }[]).map(e => e.id);
  if (!eIds.length) return [];
  const { data } = await supabase.from('einheit_eigentuemer').select('eigentuemer_id, vertrag_ab, vertrag_bis').in('einheit_id', eIds);
  return laufendeEigentuemerIds((data || []) as Zeile[], heute);
}
